<template>
  <div class="post__answer">
        <div class="post__answer--comment">
            {{`${countComm} ${t('comment', countComm)}`}}
        </div>
        <div v-if="comm.length" class="post__answer--container">
            <Comment v-for="comment in comm" :key="comment._id" :comment="comment" :collection="collection"/>
        </div>
    </div> 
</template>

<script>
import { onMounted, ref, watch } from 'vue';

import Comment from '@/components/comment/Comment';

import {useI18n} from 'vue-i18n';

import en from "@/locales/en/post/post.json";
import fr from "@/locales/fr/post/post.json";

export default {
    components: {Comment},
    props: ['comments', 'collection'],
    setup(props){

        const {t} = useI18n({
            messages:{
                en: en,
                fr: fr
                }
        })

        const countComm = ref(props.comments.length);
        const comm = ref([]);
        

        watch(()=> [...props.comments], (newVal, oldVal) => {
            comm.value =  buildCommentTree(props.comments);
            countComm.value =props.comments.length;
        })

        onMounted(()=>{
            comm.value = buildCommentTree(props.comments);
        })


        const buildCommentTree = (comments, parentComment = undefined) => {
            let newArray = [];
            let arrComment = [...comments];

            arrComment.forEach(comment => {
                let c = {...comment};
                if(c.parentComment === parentComment){
                    const children = buildCommentTree(comments, c._id);
                    if(children){
                        c.response = children;
                    }
                    newArray.push(c);
                }
            });
            return newArray;
        }

         

        return{
            comm,
            countComm,
            t
        }


    }

}
</script>

<style lang="scss" scoped>
@import '@/style/main';

.post{
    &__answer{
          margin: 4rem 0;
        display: flex;
        flex-direction: column;
         &--comment{
            margin: 0 auto;
            border: 1px solid $color-grey-50;
            box-shadow: $shadow;
            padding: 1rem 2rem;
            text-transform: uppercase;
            font-size: 1.2rem;
            letter-spacing: .1rem;

            margin-bottom: 2rem;
            background-color: $color-white;
            
        }

        &--container{
            background-color: $color-white;
            border: 3px solid $color-grey-50;
            box-shadow: $shadow;
            padding:  1.6rem 4rem 1.6rem 5rem;
            &:empty{
                display: none;
            }
        }
    }
}

</style>